export default __webpack_public_path__ + "static/media/schema-cubicus.0dccd6da.png";